// extracted by mini-css-extract-plugin
export default {"container":"AddPath_container__yiBlV","addPathIcon":"AddPath_addPathIcon__GaKVG"};